// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module--title--2kdNb","content":"index-module--content--2fEn4"};